exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#gladlyChat_container .DropDownSearchResults__dropDownSearchResults___3bdTE {\n  background: #FFFFFF !important;\n  border: 1px solid #F9F9F9 !important;\n  border-radius: 4px !important;\n  -webkit-box-sizing: border-box !important;\n          box-sizing: border-box !important;\n  -webkit-box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.11) !important;\n          box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.11) !important;\n  max-height: 166px !important;\n  margin: 0px 0px 0px 11px !important;\n  overflow: scroll !important;\n  padding: 10px !important;\n  position: absolute !important;\n  width: 329px !important;\n  z-index: 1 !important;\n}", ""]);

// exports
exports.locals = {
	"dropDownSearchResults": "DropDownSearchResults__dropDownSearchResults___3bdTE"
};